import { Button, ScreenSize } from 'glints-aries';
import styled from 'styled-components';

export const SearchButton = styled(Button).attrs({
  variant: 'solid-blue',
  block: true,
})`
  margin-top: 16px;
  @media (min-width: ${ScreenSize.desktopS}px) {
    margin-top: 0;
  }

  .solid-btn-content {
    padding: 10px 20px;
    border-radius: 8px;
    font-size: 14px;
    letter-spacing: 1px;
    @media (min-width: ${ScreenSize.desktopS}px) {
      width: 170px;
    }
  }
`;
